import { Typography } from '@material-ui/core';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import AccountVerification from '@swf/components/AccountVerification';

import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_ID_verification_required,
  TXTWCL_Verify_your_identity_to_keep_y_ELL,
  TXTWCL_YouXre_currently_using_an_unve_ELL
} from './TempAccountLimit.messages.json';
import { content } from './TempAccountLimit.scss';

interface Props {
  onClose(): void;
}

const TempAccountLimit: React.FC<Props> = ({ onClose }) => (
  <Prompt
    onClose={onClose}
    variant="default"
    title={{ translation: TXTWCL_ID_verification_required }}
  >
    <AccountVerification className={content} showButton onClose={onClose}>
      <Typography component="div">
        <p>
          <Translation {...TXTWCL_YouXre_currently_using_an_unve_ELL} />{' '}
          <Translation {...TXTWCL_Verify_your_identity_to_keep_y_ELL} />
        </p>
      </Typography>
    </AccountVerification>
  </Prompt>
);

export default TempAccountLimit;
